import { Component, OnInit, ViewEncapsulation, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import * as moment from 'moment';
import {BusinessRulesService} from "../../../core/business-rules/business-rules.service";
import {GameScheduleInfoModel} from "../../../core/business-rules/game-schedule-info.model";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'gameinfo-time-limit',
  templateUrl: 'gameInfo-time-limit.component.html',
  styleUrls: ['gameInfo-time-limit.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class GameInfoTimeLimitComponent implements OnInit, AfterViewInit {

  formGroup: FormGroup;
  info;
  infoLoaded: boolean = false;

  @Input() readOnly: boolean = false;

  @Input()
  set gameInfo(value) {
    this.info = value;
     setTimeout(() => {
      this.setValues();
    });
  }

  constructor(private formBuilder: FormBuilder,
              private businessService: BusinessRulesService,
              private messageService: MessageService) {
    this.formGroup = new FormGroup(
      {
        starSales: new FormControl(),
        endSales: new FormControl()
      }
    )
  }

  private static parseTime(time : string): Date {

   let momentDate = moment();
   let data = time.split(':');

   momentDate.hours(parseInt(data[0]));
   momentDate.minutes(parseInt(data[1]));
   momentDate.seconds(0);
   momentDate.milliseconds(0);

   return momentDate.toDate();
  }

  private setValues() {

    if (this.info) {

      this.infoLoaded = true;
      this.formGroup.patchValue({
        starSales: GameInfoTimeLimitComponent.parseTime(this.info.starSales),
        endSales: GameInfoTimeLimitComponent.parseTime(this.info.endSales)
      });
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  onSubmit() {

    if(this.readOnly) {
      return;
    }

    if (!this.formGroup.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Es necesario introducir toda la información.'
      });
      return;
    }

    let startTime = moment(this.formGroup.get('starSales').value);
    let endTime = moment(this.formGroup.get('endSales').value);

    /* Se resetea segundos y milisegundos.
      (Si el usuario borro el input, el componente de primeng crea un objeto date con el valor de la fecha/hora actual) */
    startTime.seconds(0);
    startTime.milliseconds(0);

    endTime.seconds(0);
    endTime.milliseconds(0);

    if (endTime.isSameOrBefore(startTime)) {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'El horario de fin de ventas debe de ser mayor al inicio de ventas'
      });
      return;
    }

    let data = new GameScheduleInfoModel();
    data.gameIdentifier = parseInt(this.info.drawNumber);
    data.startTime = startTime.format('HH:mm:ss');
    data.endTime = endTime.format('HH:mm:ss');

    this.businessService.setGameInfo(this.info.name.toLowerCase(), data)
      .subscribe(response => {

        this.formGroup.markAsPristine();
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'La actualizacion fue satisfactoria.'
        });

      }, error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/gameInfo-time-limit/gameInfo-time-limit.component.ts